import React, { useState, useEffect } from "react";
import "./CreateUserModal.css";
import ConfirmCreateModal from "../ConfirmCreateModal/ConfirmCreateModal";
import { useToast } from "../Toast/ToastContainer";
// Map Role từ UI sang API Enum
const ROLE_MAPPING = {
    "VIEWER": "VIEWER",
    "OPERATOR": "OPERATOR_LV1", // Giả định Operator là Level 1
    "SUPERVISOR": "SUPERVISOR"
};
export default function CreateUserModal({ isOpen, onClose, onSubmit, agentId, agentCif, agentName, isCenter,
    branchCode, unitName }) {
    const toast = useToast();

    // State form
    const [form, setForm] = useState({
        customerCode: "",    // Mã KH (Input)
        customerName: "",    // Tên KH (Readonly - từ Lookup)
        phone: "",           // SĐT (Readonly - từ Lookup)
        email: "",           // Email (Editable - từ Lookup)
        username: "",        // Username (Readonly - từ Lookup)
        channel: "Notice (Digimi) và Email",
        role: "VIEWER",      // Default
        depositLimit: "0",   // Hạn mức nộp
        withdrawLimit: "0",  // Hạn mức rút (API hiện tại chưa thấy field này, nhưng giữ lại UI)

        // Thông tin người tạo (Lấy từ Token hoặc Hardcode tạm)
        createdBy: localStorage.getItem("username") || "admin",
        staffName: localStorage.getItem("full_name") || "Admin User",
        // Lấy thẳng từ props truyền vào
        branchCode: branchCode || "",
        unitName: unitName || ""
    });
    const [openConfirm, setOpenConfirm] = useState(false);
    const [isLoadingLookup, setIsLoadingLookup] = useState(false);
    // Reset form khi mở Modal
    useEffect(() => {
        if (isOpen) {
            setForm(prev => ({
                ...prev,
                customerCode: "",
                customerName: "",
                phone: "",
                email: "",
                username: "",
                role: "VIEWER",
                depositLimit: "",
                withdrawLimit: "",
                branchCode: branchCode || "", // Đảm bảo khi mở lên là có sẵn
                unitName: unitName || ""
            }));

            // TODO: Bạn có thể decode JWT ở đây để lấy thông tin createdBy, branchCode thật
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const update = (key, val) => {
        setForm({ ...form, [key]: val });
    };
    const stop = (e) => e.stopPropagation();
    // --- 1. XỬ LÝ LOOKUP MÃ KHÁCH HÀNG ---
    const handleLookupCustomer = async () => {
        if (!form.customerCode) {
            toast.warning("Vui lòng nhập Mã khách hàng (CIF)!");
            return;
        }

        setIsLoadingLookup(true);
        try {
            const token = localStorage.getItem("access_token");
            const url = `https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/lookup/customer?agent_id=${agentId}&customer_cif=${form.customerCode}`;

            const response = await fetch(url, {
                method: "GET",
                headers: { "Authorization": `Bearer ${token}` }
            });

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.detail || "Không tìm thấy thông tin khách hàng");
            }

            const data = await response.json();

            // Kiểm tra trùng lặp
            if (data.duplicated_in_same_agent) {
                toast.error(`Mã KH ${data.customer_cif} đã tồn tại User trong đại lý này!`);
                return;
            }
            if (data.duplicated_agents && data.duplicated_agents.length > 0) {
                toast.warning(`Lưu ý: Mã KH này đã có tài khoản tại đại lý khác.`);
            }

            // Fill dữ liệu vào form
            setForm(prev => ({
                ...prev,
                customerName: data.customer_name,
                phone: data.phone,
                email: data.email || "", // Cho phép sửa nếu null
                username: data.suggested_username // Username gợi ý
            }));

        } catch (error) {
            console.error(error);
            toast.error(error.message);
            // Reset các trường liên quan nếu lỗi
            setForm(prev => ({ ...prev, customerName: "", phone: "", email: "", username: "" }));
        } finally {
            setIsLoadingLookup(false);
        }
    };
    // Hàm render danh sách quyền dựa trên isCenter
    const renderRoleOptions = () => {
        const roles = [
            { value: "OPERATOR_LV1", label: "Operator nhập" },
            { value: "OPERATOR_LV2", label: "Operator đi thẳng" },
            { value: "SUPERVISOR", label: "Supervisor" },
        ];

        // Nếu là đại lý trung tâm (isCenter === true), thêm quyền Admin
        if (isCenter) {
            roles.push({ value: "ADMIN", label: "Admin" });
        }

        return roles.map(role => (
            <option key={role.value} value={role.value}>{role.label}</option>
        ));
    };
    // --- 2. XỬ LÝ TẠO USER (SUBMIT) ---
    const handleCreateUser = async () => {
        try {
            const token = localStorage.getItem("access_token");

            // Map payload theo API document
            const payload = {
                agent_id: agentId,
                customer_cif: form.customerCode,
                email: form.email,
                username: form.username, // <--- BỔ SUNG TRƯỜNG NÀY
                role: form.role,         // Lấy trực tiếp giá trị từ select (ADMIN, OPERATOR_LV1...)
                // --- SỬA Ở ĐÂY: Gửi 2 trường riêng biệt ---
                daily_deposit_limit: parseInt(form.depositLimit.replace(/\./g, "")) || 0,
                daily_withdraw_limit: parseInt(form.withdrawLimit.replace(/\./g, "")) || 0
            };

            const response = await fetch("https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/create", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.detail || "Lỗi khi tạo user");
            }

            const result = await response.json();

            toast.success(`Tạo user ${result.username} thành công!`);

            if (onSubmit) onSubmit(result); // Callback về cha để reload list

        } catch (error) {
            console.error(error);
            toast.error(error.message);
        }
    };
    const handleSubmit = () => {
        if (onSubmit) onSubmit(form);
    };

    return (
        <div className="create-user-overlay" onClick={onClose}>
            <div className="create-user-modal" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="create-user-header">
                    <h2>Tạo tài khoản người dùng</h2>
                    <button className="create-user-close" onClick={onClose}>✕</button>
                </div>

                {/* Body */}
                <div className="create-user-body">
                    <form className="create-user-form" onSubmit={(e) => e.preventDefault()}>

                        {/* CIF Đại lý (Readonly từ Props) */}
                        <div className="cu-field">
                            <label>CIF Đại lý thanh toán <span className="required">*</span></label>
                            <input type="text" value={agentCif || ""} readOnly className="read-only-field" />
                        </div>

                        {/* Tên Đại lý (Readonly từ Props) */}
                        <div className="cu-field">
                            <label>Tên Đại lý thanh toán <span className="required">*</span></label>
                            <input type="text" value={agentName || ""} readOnly className="read-only-field" />
                        </div>

                        {/* Mã KH (Có nút Search) */}
                        <div className="cu-field">
                            <label>Mã khách hàng <span className="required">*</span></label>
                            <div className="cu-input-icon">
                                <input
                                    type="text"
                                    value={form.customerCode}
                                    onChange={(e) => update("customerCode", e.target.value)}
                                    placeholder="Nhập CIF User (VD: CIF_REP_001)"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Chặn hành vi submit form mặc định
                                            handleLookupCustomer();
                                        }
                                    }} />
                                {/* Nút search icon click */}
                                <span
                                    className={`cu-icon-search ${isLoadingLookup ? "loading" : ""}`}
                                    onClick={handleLookupCustomer}
                                    style={{ cursor: 'pointer' }}
                                    title="Tra cứu"
                                />
                            </div>
                        </div>

                        {/* Tên KH (Auto fill) */}
                        <div className="cu-field">
                            <label>Tên khách hàng</label>
                            <input type="text" value={form.customerName} readOnly className="read-only-field" />
                        </div>

                        {/* Điện thoại (Auto fill) */}
                        <div className="cu-field">
                            <label>Điện thoại <span className="required">*</span></label>
                            <input type="text" value={form.phone} readOnly className="read-only-field" />
                        </div>

                        {/* Email (Editable) */}
                        <div className="cu-field">
                            <label>Email</label>
                            <input
                                type="text"
                                value={form.email}
                                onChange={(e) => update("email", e.target.value)}
                            />
                        </div>

                        {/* Username (Auto fill) */}
                        <div className="cu-field">
                            <label>Username <span className="required">*</span></label>
                            <input
                                type="text"
                                value={form.username}
                                onChange={(e) => update("username", e.target.value)}
                            />
                        </div>

                        {/* Kênh nhận Password */}
                        <div className="cu-field">
                            <label>Kênh nhận user/Password</label>
                            <select
                                value={form.channel}
                                onChange={(e) => update("channel", e.target.value)}
                            >
                                <option>Notice (Digimi) và Email</option>
                                <option>Email</option>
                                <option>SMS</option>
                            </select>
                        </div>

                        {/* Role */}
                        <div className="cu-field">
                            <label>Nhóm quyền app Đại lý <span className="required">*</span></label>
                            <select
                                value={form.role}
                                onChange={(e) => update("role", e.target.value)}
                            >
                                {renderRoleOptions()}
                            </select>
                        </div>

                        {/* Trạng thái (Disabled - Mặc định khi tạo mới) */}
                        <div className="cu-field">
                            <label>Trạng thái</label>
                            <input type="text" value="Chờ kích hoạt" disabled className="read-only-field" />
                        </div>

                        {/* Hạn mức nộp */}
                        <div className="cu-field">
                            <label>Hạn mức nộp trong ngày <span className="required">*</span></label>
                            <select
                                value={form.depositLimit}
                                onChange={(e) => update("depositLimit", e.target.value)}
                            >
                                <option value="0">-- Chọn hạn mức --</option>
                                <option value="5.000.000">5.000.000 VND</option>
                                <option value="10.000.000">10.000.000 VND</option>
                                <option value="20.000.000">20.000.000 VND</option>
                                <option value="50.000.000">50.000.000 VND</option>
                                <option value="100.000.000">100.000.000 VND</option>
                                <option value="200.000.000">200.000.000 VND</option>
                                <option value="999.999.999">999.999.999 VND</option>

                            </select>
                        </div>

                        {/* Hạn mức rút (UI Only - Vì API mẫu chỉ có daily_limit) */}
                        <div className="cu-field">
                            <label>Hạn mức rút trong ngày <span className="required">*</span></label>
                            <select
                                value={form.withdrawLimit}
                                onChange={(e) => update("withdrawLimit", e.target.value)}
                            >
                                <option value="0">-- Chọn hạn mức --</option>
                                <option value="5.000.000">5.000.000 VND</option>
                                <option value="10.000.000">10.000.000 VND</option>
                                <option value="20.000.000">20.000.000 VND</option>
                                <option value="50.000.000">50.000.000 VND</option>
                                <option value="100.000.000">100.000.000 VND</option>
                                <option value="200.000.000">200.000.000 VND</option>
                                <option value="999.999.999">999.999.999 VND</option>
                            </select>
                        </div>

                        {/* Info người tạo (Readonly) */}
                        <div className="cu-field"><label>User tạo</label><input type="text" value={form.createdBy} readOnly className="read-only-field" /></div>
                        <div className="cu-field"><label>Tên CBNV</label><input type="text" value={form.staffName} readOnly className="read-only-field" /></div>
                        <div className="cu-field"><label>Branch tạo</label><input type="text" value={form.branchCode} readOnly className="read-only-field" /></div>
                        <div className="cu-field"><label>Tên ĐVKD</label><input type="text" value={form.unitName} readOnly className="read-only-field" /></div>

                    </form>
                </div>

                {/* Footer */}
                <div className="create-user-footer">
                    <button className="cu-btn-back" onClick={onClose}>Quay về</button>
                    <button
                        className="cu-btn-submit"
                        onClick={() => {
                            // Validate cơ bản trước khi mở popup confirm
                            if (!form.customerCode || !form.username || !form.role || form.depositLimit === "0") {
                                toast.warning("Vui lòng điền đầy đủ các trường bắt buộc (*)");
                                return;
                            }
                            setOpenConfirm(true);
                        }}
                    >
                        Đăng ký
                    </button>
                </div>

            </div>

            {/* Popup xác nhận cuối cùng */}
            <ConfirmCreateModal
                isOpen={openConfirm}
                message={`Bạn có chắc chắn muốn tạo user ${form.username}?`}
                onConfirm={() => {
                    setOpenConfirm(false);
                    handleCreateUser();
                }}
                onCancel={() => setOpenConfirm(false)}
            />
        </div>
    );
}